import { Form, Formik } from "formik";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";
import FormControl from "@mui/material/FormControl";
import { TextField, CircularProgress } from "@mui/material";
import SearchComponent from "../../../components/OB/SearchComponent";
import TableComponent from "../../../components/OB/TableComponent";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useEffect, useState } from "react";
import "./MeclisKararlari.css"
import { showToast } from "../../../helpers/ToastifyHelper";
import MeclisKararlariAPI from "../../../apis/OB/Get/MeclisKararlariAPI";
import { changeDateFormat } from "../../../helpers/DateFormat";


const MeclisKararlari: React.FC = () => {
    //Input UseStateleri
    const [ilkTarih, setIlkTarih] = useState<any>(null);
    const [sonTarih, setSonTarih] = useState<any>(null);
    const [kararNo, setKararNo] = useState("");
    const [icerik, setIcerik] = useState("");
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const [requestControl, setRequestControl] = useState<boolean>(false);
    const [isSearched, setIsSearched] = useState<boolean>(false);
    const [isLoading, setisLoading] = useState<boolean>(false);

    const columns = [
        { header: "Detay", field: "kararIcerigiBase64", className: "text-center", exportFileBase64: true, exportfileName: "meclisKararlari" },
        { header: "Karar Tarihi", field: "kararTarihi", className: "text-center" },
        { header: "Karar Saati", field: "kararSaati", className: "text-center" },
        { header: "Karar Numarası", field: "kararNumarasi", className: "text-center" },
        { header: "Konusu", field: "konusu", className: "text-center" },
        { header: "İlgili müdürlük", field: "mudurlukAdi", className: "text-center" },
        { header: "Özet", field: "ozet", className: "text-center" },
    ];

    //Meclis Kararlari Api 
    const fetchData = async () => {
        if (ilkTarih !== null && sonTarih !== null) {
            setisLoading(true);
            if (ilkTarih > sonTarih) {
                showToast("İlk tarih son tarihten büyük olamaz", "error",);
                return;
            }
            const response = await MeclisKararlariAPI.getMeclisKararlariListe(
                ilkTarih.toString(),
                sonTarih.toString(),
                kararNo,
                icerik
            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)
            setIsSearched(true);

        }
        else {
            setSearchControl(false)
            showToast("ilk tarih ve son tarih alanları zorunludur", "error");
        }
    }
    const [data, setData] = useState<any[]>([]);

    //Temizleme fonksiyonu
    const handleTemizle = () => {
        setIlkTarih(null);
        setSonTarih(null);
        setKararNo("");
        setIcerik("");
    }
    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (

        <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <DatePicker label="İlk Tarih"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                color: ilkTarih == null && searchControl == false ? "error" : "primary"
                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                            },
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: ilkTarih == null && searchControl == false ? '1px solid red' : '' },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: ilkTarih == null && searchControl == false ? '1px solid red' : '' },
                                        }}
                                        value={ilkTarih || null}
                                        onChange={(newValue: any) => {
                                            setIlkTarih(newValue || null);
                                        }}
                                    />
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <DatePicker label="Son Tarih"
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                color: sonTarih == null && searchControl == false ? "error" : "primary"

                                            },
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                            },
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: sonTarih == null && searchControl == false ? '1px solid red' : '' },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: sonTarih == null && searchControl == false ? '1px solid red' : '' },
                                        }}
                                        value={sonTarih || null} //search kontrol ile zorunlu alan ifadesi yapabiliyoruz
                                        onChange={(newValue: any) => {
                                            setSonTarih(newValue || null);
                                        }}
                                    />
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <TextField id="" label="Karar No" variant="outlined" size="small"
                                        value={kararNo}
                                        onChange={(e) => {
                                            setKararNo(e.target.value);
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                            },
                                        }}
                                    />
                                </FormControl>
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <TextField id="" label="İçerik" variant="outlined" size="small"
                                        value={icerik}
                                        onChange={(e) => {
                                            setIcerik(e.target.value);
                                        }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: 'white', // Arka plan rengini beyaz yapar
                                            },
                                        }}
                                    />
                                </FormControl>
                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                        <CircularProgress />
                    </div>
                    :
                    <TableComponent columns={columns} data={data} recordsPerPage={10} isSearched={isSearched}></TableComponent>
                }
            </div >
        </div >

    )
}
export default MeclisKararlari;